import { useTranslate } from 'react-polyglot';

import { useCopySessionLink } from '../../../../../../../../../../shared/application/hooks/useCopySessionLink';
import { StyledCopyIcon, Text, Wrapper } from './CopyLinkAction.styled';

export const CopyLinkAction = () => {
  const t = useTranslate();

  const { handleCopySessionClick } = useCopySessionLink('game');

  return (
    <Wrapper onClick={handleCopySessionClick}>
      <StyledCopyIcon />
      <Text>{t('__new.play.creatorLobby.copyLink.button')}</Text>
    </Wrapper>
  );
};
